module.exports = __webpack_public_path__ + "assets/ic_arrow_right4.ed75ebf6.svg";